import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1512 456"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "url(#i-1068403639__a)",
      "stroke-width": "26",
      d: "M-23.346 312.45c78.703-190.071 300.138-445.461 564.122-195.108 122.683 116.348 155.675 181.806 244.26 263.707 88.586 81.901 206.037 92.667 321.984-34.713 216.61-237.975 334.19-240.003 473.67-45.091",
      opacity: ".45"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "i-1068403639__a",
        x1: "-24.29",
        x2: "2262.25",
        y1: "177.474",
        y2: "296.859",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#fff" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#77B7DD"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }